var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "bell_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.243 3.757A6 6 0 0 1 18 8c0 7 3 9 3 9H3s3-2 3-9a6 6 0 0 1 10.243-4.243ZM13.73 21a1.999 1.999 0 0 1-3.46 0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgBell as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTYuMjQyNiAzLjc1NzM2QzE3LjM2NzkgNC44ODI1OCAxOCA2LjQwODcgMTggOEMxOCAxNSAyMSAxNyAyMSAxN0gzQzMgMTcgNiAxNSA2IDhDNiA2LjQwODcgNi42MzIxNCA0Ljg4MjU4IDcuNzU3MzYgMy43NTczNkM4Ljg4MjU4IDIuNjMyMTQgMTAuNDA4NyAyIDEyIDJDMTMuNTkxMyAyIDE1LjExNzQgMi42MzIxNCAxNi4yNDI2IDMuNzU3MzZaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNMTMuNzMgMjFDMTMuNTU0MiAyMS4zMDMxIDEzLjMwMTkgMjEuNTU0NyAxMi45OTgyIDIxLjcyOTVDMTIuNjk0NiAyMS45MDQ0IDEyLjM1MDQgMjEuOTk2NSAxMiAyMS45OTY1QzExLjY0OTYgMjEuOTk2NSAxMS4zMDU0IDIxLjkwNDQgMTEuMDAxOCAyMS43Mjk1QzEwLjY5ODIgMjEuNTU0NyAxMC40NDU4IDIxLjMwMzEgMTAuMjcgMjEiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";